import * as React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import UserSelect from '../../../../Elements/Select/UserSelect.jsx'
import SelectRC from 'rc-select/lib/index.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons'

export const StepOne = ({
    kedo,
    state,
    setPartialState,
    transformContactsForPayload,
}) => {
    const handleChangeRecipients = (checked, person) => {
        const updated = checked
            ? [...state.recipientDossierPersons, person]
            : state.recipientDossierPersons.filter((r) => r.id !== person.id)
        setPartialState({ recipientDossierPersons: updated })
        transformContactsForPayload(
            state.recipientUsers,
            updated,
            state.recipientCustomEmails
        )
    }

    return (
        <Row>
            <Col md={6}>
                {state.secureShareSettings && (
                    <fieldset>
                        <legend>
                            {kedo.t('Add recipients from dossier', {
                                ns: 'secureshare',
                            })}
                        </legend>
                        <Form.Group>
                            {state.dossierPersons.map((p) => (
                                <Form.Check
                                    key={p.id}
                                    type="checkbox"
                                    label={[p.name, p.email, p.mobile]
                                        .filter(Boolean)
                                        .join(' ')}
                                    checked={state.recipientDossierPersons.includes(
                                        p
                                    )}
                                    onChange={(e) =>
                                        handleChangeRecipients(
                                            e.target.checked,
                                            p
                                        )
                                    }
                                />
                            ))}
                        </Form.Group>
                    </fieldset>
                )}
                {state.secureShareSettings?.allow_add_users && (
                    <fieldset>
                        <legend>
                            {kedo.t('Add users', { ns: 'secureshare' })}
                        </legend>
                        <UserSelect
                            currentUsers={state.recipientUsers}
                            kedo={kedo}
                            onChangeUsers={(values) => {
                                setPartialState({ recipientUsers: values })
                                transformContactsForPayload(
                                    values,
                                    state.recipientDossierPersons,
                                    state.recipientCustomEmails
                                )
                            }}
                        />
                    </fieldset>
                )}
            </Col>
            {state.secureShareSettings?.allow_email_specific && (
                <Col md={6}>
                    <fieldset>
                        <legend>
                            {kedo.t('Add custom mail addresses', {
                                ns: 'secureshare',
                            })}
                        </legend>
                        <SelectRC
                            mode="tags"
                            allowClear
                            open={false}
                            className="w-100 custom-select-react"
                            value={state.recipientCustomEmails.map(
                                (i) => i.value
                            )}
                            onSearch={(value) =>
                                setPartialState({
                                    recipientCustomEmailsInput: value,
                                })
                            }
                            onChange={(newEmails: string[]) => {
                                const formatted = newEmails.map((value) => ({
                                    label: value,
                                    value,
                                }))
                                setPartialState({
                                    recipientCustomEmails: formatted,
                                })
                                transformContactsForPayload(
                                    state.recipientUsers,
                                    state.recipientDossierPersons,
                                    formatted
                                )
                            }}
                            suffixIcon={
                                <FontAwesomeIcon icon={faChevronDown} />
                            }
                            placeholder={`${kedo.t('Search')}...`}
                        />
                    </fieldset>
                </Col>
            )}
        </Row>
    )
}
